import React from 'react';
import { CreateBody } from '../../../components/CreateBody';
import CreateHeader from '../../../components/CreateHeader';
import { StyledPage } from '../../../components/StyledPage';
import EditCreateForm from '../EditCreateForm';

const MobileConsentSolutionsCreate = ({ resource, ...rest }) => {
  return (
    <StyledPage>
      <CreateHeader
        title="Create Mobile Consent Solution"
      />
      <CreateBody {...rest} resource="universal_consent_solutions">
        <EditCreateForm cancelUrl="/universal_consent_solutions"/>
      </CreateBody>
    </StyledPage>
  );
};

export default MobileConsentSolutionsCreate;
